// extracted by mini-css-extract-plugin
export default {"container":"TextArea_container__d91ZU","label":"TextArea_label__EPv7o","input":"TextArea_input__z3YTH"};